import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=9ee8e4fe&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=9ee8e4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee8e4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ee8e4fe')) {
      api.createRecord('9ee8e4fe', component.options)
    } else {
      api.reload('9ee8e4fe', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=9ee8e4fe&scoped=true&", function () {
      api.rerender('9ee8e4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J47z4ZymxpAG/JS/comp/DocBox.vue"
export default component.exports